/* Script Collection Page */

var $categoryTitle = ".category__container p.category__text";

$( document ).ready(function() {

  /*var $url = window.location.pathname;
    
  $( ".section-shop-by-category__products .category__container" ).each(function() {
      var $idUrl = $(this).find('a').attr('href');
      if($url == $idUrl){
         $(this).addClass('active-category');
      };
  });*/
  
  var $heighText = $($categoryTitle).map(function (){
    return $(this).height();
  }).get();

  var $minHeightText = Math.max.apply(null, $heighText);

  $($categoryTitle).css({
    'min-height':$minHeightText
  });
  
});

function textCategory() {
     $($categoryTitle).css({
      'min-height':'0'
    });
    
    var $heighText = $($categoryTitle).map(function (){
      return $(this).height();
    }).get();
    
    var $minHeightText = Math.max.apply(null, $heighText);
    
    $($categoryTitle).css({
      'min-height':$minHeightText
    });

};

$( window ).resize(function() {
  setTimeout(textCategory, 200);
});